import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DealSetupState, FutureConfigDraft, RCVConfigDraft } from './types/dealSetup';

const initialState: DealSetupState = {
  futureConfigDrafts: {},
  rcvConfigDrafts: {},
};

// Holds the open Future (UAF) and new RCV deal config forms per game so edits survive Deal Setup tab switches
export const DealSetupData = createSlice({
  name: 'DealSetup',
  initialState,
  reducers: {
    setFutureConfigDraft: (
      state: DealSetupState,
      { payload }: PayloadAction<{ gameId: string; draft: FutureConfigDraft }>,
    ) => {
      state.futureConfigDrafts[payload.gameId] = payload.draft;
    },
    clearFutureConfigDraft: (state: DealSetupState, { payload }: PayloadAction<string>) => {
      delete state.futureConfigDrafts[payload];
    },
    setRCVConfigDraft: (
      state: DealSetupState,
      { payload }: PayloadAction<{ gameId: string; draft: RCVConfigDraft }>,
    ) => {
      state.rcvConfigDrafts[payload.gameId] = payload.draft;
    },
    clearRCVConfigDraft: (state: DealSetupState, { payload }: PayloadAction<string>) => {
      delete state.rcvConfigDrafts[payload];
    },
    resetDealSetupDrafts: () => {
      return initialState;
    },
  },
});

export const {
  setFutureConfigDraft,
  clearFutureConfigDraft,
  setRCVConfigDraft,
  clearRCVConfigDraft,
  resetDealSetupDrafts,
} = DealSetupData.actions;

export default DealSetupData.reducer;
